import * as Models from "../../ts/rlAdmin.models";
import * as Consts from "../../ts/rlAdmin.consts";
import { NotifyService } from "../../services/notify-service";
import { WorkflowConfigService } from "../../services/workflow-config-service";
import { FinancialPeriodService } from "../../services/financial-period-service";
import Datelocaleservice = require("../../services/date-locale-service");
import DateLocaleService = Datelocaleservice.DateLocaleService;

export class FinancialPeriodController {
	static $inject = ["$scope", "$window", "workflowConfigService", "financialPeriodService", "notifyService", "$q", "dateLocaleService"];
	charTypeID: number;
	amountProcesses: Models.IWFProcessConfig[];
	amountProcessActions: { [id: number]: Models.IWFActionConfig[] };
	allCharTypes: Models.ICharacteristicType[];
	amountProcessSelectedAction: { [id: number]: Models.IWFActionConfig };
	originalAmountProcessSelectedAction: { [id: number]: Models.IWFActionConfig };
	lockActionAlreadyCreated: Map<number, boolean>;
	lockActionsChanged: boolean;
	financialPeriods: Models.IFinancialPeriod[];
	validationErrors: string[] = [];
	errorRows: string[];

	page: number = 1;
	rowCount: number = 10;
	pageCount: number;
	numFound: number;
	sortField: string;
	sortDir: number;

	openModal: boolean;
	isCreating: boolean;
	isEditing: boolean;
	selectedPeriod: Models.IFinancialPeriod;
	startDateEdit: string;
	endDateEdit: string;

	constructor(private $scope: ng.IScope, private $window: ng.IWindowService, private workflowConfigService: WorkflowConfigService, private financialPeriodService: FinancialPeriodService,
		private notifyService: NotifyService, private $q: ng.IQService, private dateLocaleService: DateLocaleService) {
		this.charTypeID = -1;
		this.amountProcesses = [];
		this.allCharTypes = [];
		this.amountProcessActions = {};
		this.amountProcessSelectedAction = {};
		this.originalAmountProcessSelectedAction = {};
		this.lockActionAlreadyCreated = new Map<number, boolean>();
		this.lockActionsChanged = false;
		this.financialPeriods = [];
		this.sortField = "StartDate";
		this.sortDir = 0;

		$scope.$watch(() => [this.page, this.rowCount, this.sortField, this.sortDir],
			(newValue, oldValue) => {
				if (newValue != oldValue) {
					this.LoadFinancialPeriods();
				}
			}, true);

	}

	Init() {
		this.LoadAmountProcesses(this.charTypeID);
		this.LoadFinancialPeriods();
		this.$scope.$watch(() => this.amountProcessSelectedAction, (newValue: { [id: number]: Models.IWFActionConfig }, oldValue: { [id: number]: Models.IWFActionConfig }) => {
			this.lockActionsChanged = false;
			if (this.originalAmountProcessSelectedAction != null) {
				_.forEach(this.amountProcesses, key => {
					if (this.originalAmountProcessSelectedAction[key.processID] != newValue[key.processID]) {
						this.lockActionsChanged = true;
					}
				});
			}
			else {
				this.lockActionsChanged = false;
			}
		}, true);
	}

	LoadFinancialPeriods() {
		this.financialPeriodService.getFinancialPeriods(this.page, this.rowCount, this.sortField, this.sortDir).then(response => {
			response.data = response.data.map(x => {
				// fix start/end dates coming back as strings
				x.startDate = new Date(x.startDate);
				x.endDate = new Date(x.endDate);

				return x;
			});

			this.financialPeriods = response.data;
			this.pageCount = response.pageCount;
			this.numFound = response.numFound;
		});

		this.financialPeriodService.validateFinancialPeriods().then(response => {
			this.validationErrors = response.data;
			this.errorRows = response.data.map(x => x.split(" ")[0]);
		});
	}

	IsErrorRow(period: Models.IFinancialPeriod) {
		return this.errorRows.indexOf(`${period.year}-${period.period}`) >= 0;
	}

	View(period: Models.IFinancialPeriod) {
		this.isEditing = false;
		this.isCreating = false;
		this.selectedPeriod = period;
		this.openModal = true;
	}

	Create() {
		this.startDateEdit = "";
		this.endDateEdit = "";
		this.$scope['editFinancialPeriodForm'].$setPristine(true);
		this.$scope['editFinancialPeriodForm'].$setUntouched();
		this.selectedPeriod = <Models.IFinancialPeriod>{};
		this.openModal = true;
		this.isEditing = true;
		this.isCreating = true;
	}

	Edit(model: Models.IFinancialPeriod) {
		this.selectedPeriod = this.deepClone(model);
		this.selectedPeriod.startDate = new Date(this.selectedPeriod.startDate);
		this.selectedPeriod.endDate = new Date(this.selectedPeriod.endDate);

		this.startDateEdit = this.dateLocaleService.parseDateMoment(this.selectedPeriod.startDate).format("L");
		this.endDateEdit = this.dateLocaleService.parseDateMoment(this.selectedPeriod.endDate).format("L");

		this.isEditing = true;
		this.openModal = true;
		this.isCreating = false;
	}

	Delete(period: Models.IFinancialPeriod) {
		this.financialPeriodService.deleteFinancialPeriod(period).then(x => {
			this.LoadFinancialPeriods();
		});
	}

	Save() {
		this.selectedPeriod.startDate = new Date(this.startDateEdit);
		this.selectedPeriod.endDate = new Date(this.endDateEdit);

		if (this.isCreating) {
			this.financialPeriodService.createFinancialPeriod(this.selectedPeriod).then(response => {
				this.Init();
			});
		} else if (this.isEditing) {
			this.financialPeriodService.updateFinancialPeriod(this.selectedPeriod).then(response => {
				this.Init();
			});
		}
	}

	private deepClone(obj) {
		return _.cloneDeep(obj);
	}

	LockPastPeriod(period: Models.IFinancialPeriod) {
		this.notifyService.startProgress();
		this.financialPeriodService.updateAmountToLockedStatusByDueDate(period).then(() => {
			this.notifyService.notifySuccess("Amounts locked successfully");
			this.notifyService.endProgress();
			this.Init();
		});
	}

	CanLockRow(period: Models.IFinancialPeriod) {
		// only show lock button for very first lockable period
		const first = this.financialPeriods.find(x => x.status === 0 && x.endDate < new Date());
		return first && period.id === first.id;
	}

	LoadAmountProcesses(charTypeID: number): ng.IPromise<any> {
		this.notifyService.startProgress();
		return this.workflowConfigService.getProcessesWithSteps(charTypeID)
			.then((result) => {
				this.amountProcesses = [];
				_.forEach(result, r => {
					if (r.charTypeID == Consts.CharTypeIDs.amount) {
						this.amountProcesses.push(r);
					}
				});
			}).finally(() => {
				this.LoadProcessActions();
				this.notifyService.endProgress();
			});
	}

	LoadProcessActions() {
		this.notifyService.startProgress();

		_.forEach(this.amountProcesses, process => {
			this.financialPeriodService.getWorkflowConfigActionsWithLockedStatus(process.processID, process.charTypeID)
				.then((result) => {
					this.amountProcessActions[process.processID] = result;
					//replace this with getting data from DB and selecting that
					this.financialPeriodService.getWorkflowLockedAction(process.processID).then((result1) => {
						if (result1.data !== -1) {
							this.amountProcessSelectedAction[process.processID] = result.find(r => r.actionID == result1.data);
							this.originalAmountProcessSelectedAction[process.processID] = this.amountProcessSelectedAction[process.processID];
							this.lockActionAlreadyCreated[process.processID] = true;
						}
						else {
							this.amountProcessSelectedAction[process.processID] = null;
							this.originalAmountProcessSelectedAction[process.processID] = null;
							this.lockActionAlreadyCreated[process.processID] = false;
						}
					});
				});
		});
		this.notifyService.endProgress();
	}

	SaveProcessActions() {
		this.notifyService.startProgress();
		let promises = [];
		_.forEach(this.amountProcesses, key => {
			if (this.lockActionAlreadyCreated[key.processID]) {
				if (this.amountProcessSelectedAction[key.processID] == null) {
					promises.push(this.financialPeriodService.deleteWorkflowLockedAction(key.processID))
				}
				else {
					promises.push(this.financialPeriodService.updateWorkflowLockedAction(key.processID, this.amountProcessSelectedAction[key.processID].actionID))
				}
			}
			else if (this.amountProcessSelectedAction[key.processID] != null) {
				promises.push(this.financialPeriodService.createWorfklowLockedAction(key.processID, this.amountProcessSelectedAction[key.processID].actionID))
			}
			//Update original value to check against for enabling save button
			this.originalAmountProcessSelectedAction[key.processID] = this.amountProcessSelectedAction[key.processID];
			this.lockActionsChanged = false;
		});
		this.$q.all(promises).then(() => {
			this.notifyService.notifySuccess("Saved successfully");
			this.notifyService.endProgress();
		});

	}

}